module.exports = __webpack_public_path__ + "static/implant2-bf363d4a0b2310aff9c4ff9172e1d9ff.jpg";